<dynamic-form [apiName]="apiName"
              [label]="label"
              [group]="formGroup"
              [areaName]="areaName"
              [model]="model"
              [columns]="columns"
              (valueChange)="valueChange($event)"
              (cancelChange)="cancel()"
              (submitChange)="save()">              
              <div class="content">
              <template-input 
                    name="Text"
                    [(textValue)]="model.Text"
                    [group]="formGroup"
                    [items]="model.MessageTemplateTypeCode==messageTemplateType.occasion ? occasionItems :groupItems"
                    [placeholder]="'ClientApp.FrontOffice.Messaging.TemplateMessage.Text' | translate">
              </template-input>
              </div>    
</dynamic-form>
